import React, { Component } from "react";
import "./WhatsAppInQueue.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { APPLICATION_NAME } from "../../core/constants";
import WhatsApp from "./WhatsApp";

const initialState = {

}

class WhatsAppInQueue extends Component
{
    state = {...initialState}
    
    componentDidMount = async () => 
    {
        document.title = `${APPLICATION_NAME} - WhatsApp (na fila)`;
    }

    componentDidUpdate = async (prevProps, prevState) => 
    {
        // console.log("WHATSAPP IN PROGRESS prevProps ", prevProps);
        // console.log("WHATSAPP IN PROGRESS this.props ", this.props);
    }

    render ()
    {
        return (
            <div className="whatsAppInQueue">
                <WhatsApp idUserCRM={this.props.idUserCRM} />
            </div>
        )
    }
}

function mapStateToProps (state)
{
    const {user} = state.auth;
    const permissions = state.permissions;
    const {hasPermissionsLoaded, whatsapp} = permissions;

    return {
        user,
        whatsapp,
        permissions,
        hasPermissionsLoaded,
    }
}

function mapDispatchToProps (dispatch)
{
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WhatsAppInQueue));